import React, { useEffect, useState } from "react";
import { MainStyled, VehicleTypeStyled } from "./vehicleType.styles";
import { useDispatch, useSelector } from "react-redux";
import "../../app/App.css";
import {
  selectNewRequestSelectedVehicle,
  selectVehicleRequestedType,
} from "../../redux/newRequest/newRequest.selectors";
import { setSelectedVehicleRequested } from "../../redux/newRequest/newRequest.actions";
const VehicleType = () => {
  const dispatch = useDispatch();
  const SelectedVehicle = useSelector(selectNewRequestSelectedVehicle);
  const SelectedVehicleRequestedTypeId = useSelector(
    selectVehicleRequestedType
  );
  useEffect(() => {
    if (SelectedVehicle)
      dispatch(setSelectedVehicleRequested(SelectedVehicle.type[0]._id));
  }, [SelectedVehicle, dispatch]);
  const SetRequestedVehicleType = (id) => {
    dispatch(setSelectedVehicleRequested(id));
  };
  // const scrollContainer = document.querySelector(".reqinfo-details");
  // scrollContainer?.addEventListener("wheel", (evt) => {
  //   evt.preventDefault();
  //   scrollContainer.scrollLeft += evt.deltaY;
  // });
  return (
    <>
        {SelectedVehicle ? (
          <MainStyled>
            {SelectedVehicle?.type?.map((item, index) => (
              <VehicleTypeStyled
                key={index}
                className={`c-pointer ${
                  SelectedVehicleRequestedTypeId === item._id ? "selected" : ""
                }`}
                onClick={() => SetRequestedVehicleType(item._id)}
              >
                {item.t_name}
              </VehicleTypeStyled>
            ))}
          </MainStyled>
        ) : (
          ""
        )}
    </>
  );
};

export default VehicleType;
